import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules'
import {CloudPDFEntry, CloudPDFStore, IServerRenderedPDFTemplateInstance} from '@modules/pdf'
import {StoresInstance} from '@stores'
import * as css from './PDFServerRenderedContainer.css'


/// region Store

export class PDFServerRenderedContainerStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)

    stores.cloudPDF.component = this
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @observable.ref rootDiv : HTMLDivElement

  @action setRootRef = ref => this.rootDiv = ref

  @computed get selectedTemplate(): IServerRenderedPDFTemplateInstance {
    const {cloudPDF: {templatesById}, selectedPdf, catalog: {stores}} = this
    if (!selectedPdf) return null
    const f = templatesById[selectedPdf.template]
    return f ? f(stores) : null
  }

  @action generatePDF = async () => {
    const {
      cloudPDF: {generatePDF}, selectedTemplate,
    } = this
    if (!selectedTemplate) throw new Error(`No PDF template is selected`)

    const {queryPayload} = selectedTemplate

    const r = await generatePDF(queryPayload)

    console.log(r)
  }

  @action onDocumentLoad = (e: DocumentLoadEvent) => {
    const {doc} = e, {cloudPDF: {defaultLayoutPluginInstance: {toolbarPluginInstance: {scrollModePluginInstance}}}, selectedTemplate, rootDiv} = this
    selectedTemplate?.onDocumentLoad?.(e)

    // The PDF gets stuck on loading spinners for all but the first page until the user scrolls, attempt to bypass that issue
    const scrollContainer = rootDiv.querySelector('.rpv-core__inner-pages')
    setTimeout(() => {
      scrollContainer.scrollTop = 1
    }, 100)
  }

  set selectedPdf(v: CloudPDFEntry) {
    const {stores: {pdfConfig},} = this
    if (pdfConfig) {
      pdfConfig.pdfSettings.selectedArtifact = v?.entry?._id
    }
  }

  @computed get selectedPdf(): CloudPDFEntry {
    const {stores} = this

    const selectedArtifact = stores.pdfConfig?.pdfSettings?.selectedArtifact
    if (selectedArtifact) {
      const pdf = CloudPDFStore.generatedPdfs.get(selectedArtifact)
      if (!pdf) {
        //
      }
      return pdf
    }
    return null
  }
}

export const PDFServerRenderedContainerStoreContext = React.createContext<PDFServerRenderedContainerStore>(null)
export const usePDFServerRenderedContainerStore = () => React.useContext(PDFServerRenderedContainerStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

import {DocumentLoadEvent, Viewer} from '@react-pdf-viewer/core'
import {defaultLayoutPlugin} from '@react-pdf-viewer/default-layout'
import {Worker} from '@react-pdf-viewer/core'

import(/* webpackChunkName: "react-pdf-viewer" */ '@react-pdf-viewer/core/lib/styles/index.css')
import(/* webpackChunkName: "react-pdf-viewer" */ '@react-pdf-viewer/default-layout/lib/styles/index.css')

const useDefaultLayoutPlugin = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [
      defaultTabs[0]
    ],
  })

  return defaultLayoutPluginInstance
}
export const PDFServerRenderedContainer = observer<MyProps>(function PDFServerRenderedContainer({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new PDFServerRenderedContainerStore(stores, obsProps)),
    {cloudPDF, selectedPdf, onDocumentLoad, setRootRef} = store,
    pluginInstance = useDefaultLayoutPlugin()
    /// This is a hook so it has to be here and not in the store

  useEffect(() => {
    cloudPDF.defaultLayoutPluginInstance = pluginInstance
  }, [pluginInstance])

  useEffect(() => store.registerEffects(), [])

  return (
    <PDFServerRenderedContainerStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)} ref={setRootRef}>
        {selectedPdf && <Worker
            workerUrl="https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js"
            //workerUrl='/static/js/pdf.worker.js'
         >
          <Viewer fileUrl={selectedPdf.url}
                  plugins={[pluginInstance]}
                  // theme='dark'
                  defaultScale={.1}
                  onDocumentLoad={onDocumentLoad}
          />
        </Worker>}

      </div>
    </PDFServerRenderedContainerStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/PDFServerRenderedContainer.tsx